var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCaseno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-20-382h1150v754H-20z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 30.354)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.813,
    height: 56.454,
    x: 2.054,
    y: 2.512,
    stroke: "#000",
    strokeWidth: 3.849,
    rx: 5.132
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2.566,
    d: "M45.622 10.223v41.904"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.849,
    d: "M24.508 67.36h45.199"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#1A1A1A",
    fontFamily: "Nunito-Black, Nunito",
    fontSize: 16.68,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 18.695,
    y: 25.284
  }, "1")), /*#__PURE__*/React.createElement("text", {
    fill: "#1A1A1A",
    fontFamily: "Nunito-Black, Nunito",
    fontSize: 16.68,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 18.486,
    y: 45.993
  }, "2")), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M74.807 18.87l-5.033-5.82c-.529-.612-1.384-.612-1.913 0-.53.612-.53 1.6 0 2.213l2.724 3.15h-8.086c-.749 0-1.354.7-1.354 1.564 0 .864.605 1.565 1.354 1.565h8.086l-2.724 3.15c-.53.611-.53 1.6 0 2.212.263.305.61.458.956.458.347 0 .693-.153.957-.458l5.033-5.82c.126-.143.225-.317.294-.51a1.794 1.794 0 0 0 0-1.195 1.602 1.602 0 0 0-.294-.51zM74.807 39.578l-5.033-5.82c-.529-.611-1.384-.611-1.913 0-.53.613-.53 1.601 0 2.213l2.724 3.15h-8.086c-.749 0-1.354.7-1.354 1.565 0 .863.605 1.564 1.354 1.564h8.086L67.86 45.4c-.53.612-.53 1.6 0 2.212.263.306.61.459.956.459.347 0 .693-.153.957-.459l5.033-5.819c.126-.144.225-.317.294-.51a1.794 1.794 0 0 0 0-1.195 1.602 1.602 0 0 0-.294-.51z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCaseno);
export default __webpack_public_path__ + "static/media/icons-caseno.4809cefa3437edcb0efffb1cda33b4ef.svg";
export { ForwardRef as ReactComponent };